import {
  EXCLUDED_ACTORS_TABLE_KEY,
  INCLUDED_ACTORS_TABLE_KEY,
} from '../constants/export.constants';

export const isFieldPropUnique = ({ items = [], prop, value }) => {
  const itemsByProp = items.filter((item) => item[prop]?.toUpperCase() === value?.toUpperCase());
  return itemsByProp.length === 1;
};

const validateRequitedRows = ({ rows = [], validationErrors = [], message = '' }) => {
  const emptyRows = rows.filter((user) => !user.code);

  emptyRows.forEach((row) => {
    validationErrors.push({
      rowId: row.rowId,
      message,
    });
  });
};

const validateUniqueRows = ({ rows = [], validationErrors = [], message = '' }) => {
  const prop = 'code';

  rows.forEach((row) => {
    const isActorUnique = isFieldPropUnique({
      items: rows,
      prop,
      value: row[prop],
    });

    if (!isActorUnique) {
      validationErrors.push({
        rowId: row.rowId,
        message,
      });
    }
  });
};

export const getValidationWarnings = (errors = []) =>
  errors.map(({ rowId, message }) => ({ instanceId: rowId, message }));

export const validateExportData = ({ exportData, selectedPackages, isPackagesExport = false }) => {
  const validationErrors = [];

  if (isPackagesExport) {
    if (!selectedPackages?.length) {
      validationErrors.push({
        rowId: '',
        message: 'Select a saved package file or files to preview the Export',
      });
    }
  } else {
    validateRequitedRows({
      rows: exportData[INCLUDED_ACTORS_TABLE_KEY],
      message: 'Code in Included User table is required.',
      validationErrors,
    });

    validateRequitedRows({
      rows: exportData[EXCLUDED_ACTORS_TABLE_KEY],
      message: 'Code in Excluded Users table is required.',
      validationErrors,
    });

    if (validationErrors.length) {
      return validationErrors;
    }

    validateUniqueRows({
      rows: exportData[EXCLUDED_ACTORS_TABLE_KEY],
      message: 'Code in Excluded Users table should be unique.',
      validationErrors,
    });
  }

  return validationErrors;
};
